(() => {
  const ROOT_SELECTOR = '[data-wp-root]';

  function showToast(root, message, isError = false) {
    const toast = root.querySelector('[data-wp-toast]');
    if (!toast) return;
    toast.textContent = message;
    toast.style.borderColor = isError ? '#ef4444' : 'rgba(167,134,255,.65)';
    toast.hidden = false;
    window.clearTimeout(toast._wpTimer);
    toast._wpTimer = window.setTimeout(() => {
      toast.hidden = true;
    }, 4000);
  }

  function publish(name, data) {
    try {
      if (window.Shopify?.analytics?.publish) {
        window.Shopify.analytics.publish(name, data);
      }
    } catch (error) {
      console.debug('[WaxxPod] Analytics publish skipped', error);
    }
  }

  async function addItems(items) {
    const rootUrl = window.Shopify?.routes?.root || '/';
    const response = await fetch(`${rootUrl}cart/add.js`, {
      method: 'POST',
      headers: {
        'Content-Type': 'application/json',
        Accept: 'application/json',
      },
      body: JSON.stringify({ items }),
    });

    const payload = await response.json().catch(() => ({}));
    if (!response.ok) {
      throw new Error(payload.description || payload.message || 'Unable to add this item to the cart.');
    }
    return payload;
  }

  function redirectToCart() {
    const rootUrl = window.Shopify?.routes?.root || '/';
    window.location.assign(`${rootUrl}cart`);
  }

  function initializeHeroCarousel(root) {
    root.querySelectorAll('[data-wp-hero-carousel]').forEach((carousel) => {
      if (carousel.dataset.wpCarouselInitialized === 'true') return;
      carousel.dataset.wpCarouselInitialized = 'true';

      const track = carousel.querySelector('[data-wp-hero-track]');
      const slides = Array.from(carousel.querySelectorAll('[data-wp-hero-slide]'));
      const dots = Array.from(carousel.querySelectorAll('[data-wp-hero-dot]'));
      const previous = carousel.querySelector('[data-wp-hero-prev]');
      const next = carousel.querySelector('[data-wp-hero-next]');
      if (!track || slides.length < 2) return;

      let activeIndex = 0;
      const updateDots = (index) => {
        activeIndex = Math.max(0, Math.min(index, slides.length - 1));
        dots.forEach((dot, dotIndex) => {
          dot.setAttribute('aria-current', String(dotIndex === activeIndex));
        });
      };
      const goTo = (index) => {
        const nextIndex = (index + slides.length) % slides.length;
        track.scrollTo({ left: slides[nextIndex].offsetLeft, behavior: 'smooth' });
        updateDots(nextIndex);
      };

      previous?.addEventListener('click', () => goTo(activeIndex - 1));
      next?.addEventListener('click', () => goTo(activeIndex + 1));
      dots.forEach((dot) => {
        dot.addEventListener('click', () => goTo(Number(dot.dataset.wpHeroDot || 0)));
      });
      track.addEventListener('scroll', () => {
        const nearestIndex = Math.round(track.scrollLeft / Math.max(track.clientWidth, 1));
        if (nearestIndex !== activeIndex) updateDots(nearestIndex);
      }, { passive: true });
      track.addEventListener('keydown', (event) => {
        if (event.key === 'ArrowLeft') {
          event.preventDefault();
          goTo(activeIndex - 1);
        } else if (event.key === 'ArrowRight') {
          event.preventDefault();
          goTo(activeIndex + 1);
        }
      });
      updateDots(0);
    });
  }

  function initialize(root) {
    if (!root || root.dataset.wpInitialized === 'true') return;
    root.dataset.wpInitialized = 'true';
    document.body.classList.add('wp-landing-active');
    initializeHeroCarousel(root);

    let selectedKit = root.querySelector('[data-wp-kit].is-selected:not([disabled])') || root.querySelector('[data-wp-kit]:not([disabled])');
    let refillPacks = Number(root.querySelector('[data-wp-refill].is-selected')?.dataset.packs || 5);
    let subscriptionEnabled = root.querySelector('[data-wp-subscription]')?.classList.contains('is-on') || false;
    let busy = false;

    function setKit(target) {
      if (!target || target.disabled) return;
      const key = target.dataset.kitKey;
      const label = target.dataset.label;
      const price = target.dataset.price;
      selectedKit = target;

      root.querySelectorAll('[data-wp-kit]').forEach((button) => {
        const active = button.dataset.kitKey === key;
        button.classList.toggle('is-selected', active);
        button.setAttribute('aria-pressed', String(active));
      });
      root.querySelectorAll('[data-wp-selected-label]').forEach((node) => { node.textContent = label; });
      root.querySelectorAll('[data-wp-selected-price]').forEach((node) => { node.textContent = price; });
      root.querySelectorAll('[data-wp-payment-buttons]').forEach((node) => {
        node.hidden = node.dataset.wpPaymentButtons !== key;
      });
      publish('waxxpod_bundle_select', { kit: key, label, price });
    }

    root.querySelectorAll('[data-wp-kit]').forEach((button) => {
      button.addEventListener('click', () => setKit(button));
    });
    if (selectedKit) setKit(selectedKit);

    root.querySelectorAll('[data-wp-refill]').forEach((button) => {
      button.addEventListener('click', () => {
        if (button.disabled) return;
        refillPacks = Number(button.dataset.packs || 1);
        const stix = Number(button.dataset.stix || refillPacks * 10);
        root.querySelectorAll('[data-wp-refill]').forEach((option) => {
          const active = option === button;
          option.classList.toggle('is-selected', active);
          option.setAttribute('aria-pressed', String(active));
        });
        root.querySelectorAll('[data-wp-refill-stix]').forEach((node) => { node.textContent = String(stix); });
        publish('waxxpod_refill_select', { stix, packs: refillPacks });
      });
    });

    const subscription = root.querySelector('[data-wp-subscription]');
    const subscriptionToggle = root.querySelector('[data-wp-subscription-toggle]');
    subscriptionToggle?.addEventListener('click', () => {
      subscriptionEnabled = !subscriptionEnabled;
      subscription?.classList.toggle('is-on', subscriptionEnabled);
      subscriptionToggle.setAttribute('aria-checked', String(subscriptionEnabled));
      publish('waxxpod_subscription_toggle', {
        enabled: subscriptionEnabled,
        selling_plan_id: root.dataset.sellingPlanId || null,
      });
    });

    root.querySelectorAll('[data-wp-scroll-kits]').forEach((button) => {
      button.addEventListener('click', () => {
        root.querySelector('[data-wp-kits-section]')?.scrollIntoView({ behavior: 'smooth', block: 'start' });
      });
    });

    root.querySelectorAll('[data-wp-scroll-how]').forEach((button) => {
      button.addEventListener('click', () => {
        root.querySelector('.wp-how')?.scrollIntoView({ behavior: 'smooth', block: 'start' });
      });
    });

    root.querySelectorAll('[data-wp-add-kit]').forEach((button) => {
      button.addEventListener('click', async () => {
        const variantId = Number(selectedKit?.dataset.variantId || 0);
        if (!variantId || busy) {
          if (!variantId) showToast(root, 'Select valid Shopify products in the Theme Editor first.', true);
          return;
        }

        busy = true;
        root.querySelectorAll('[data-wp-add-kit]').forEach((node) => { node.disabled = true; });
        try {
          await addItems([{ id: variantId, quantity: 1 }]);
          publish('waxxpod_add_to_cart', { type: 'kit', variant_id: variantId, kit: selectedKit.dataset.kitKey });
          if (root.dataset.afterAdd === 'cart') redirectToCart();
          else showToast(root, `${selectedKit.dataset.label} added to cart.`);
        } catch (error) {
          showToast(root, error.message || 'Unable to add the kit to the cart.', true);
        } finally {
          busy = false;
          root.querySelectorAll('[data-wp-add-kit]').forEach((node) => { node.disabled = false; });
        }
      });
    });

    root.querySelector('[data-wp-add-refill]')?.addEventListener('click', async (event) => {
      const button = event.currentTarget;
      const variantId = Number(root.dataset.refillVariantId || 0);
      const sellingPlanId = subscriptionEnabled ? Number(root.dataset.sellingPlanId || 0) : 0;
      if (!variantId || busy) {
        if (!variantId) showToast(root, 'Select the 10-Stix refill product in the Theme Editor first.', true);
        return;
      }

      const item = { id: variantId, quantity: refillPacks };
      if (sellingPlanId) item.selling_plan = sellingPlanId;

      busy = true;
      button.disabled = true;
      try {
        await addItems([item]);
        publish('waxxpod_add_to_cart', {
          type: 'refill',
          variant_id: variantId,
          packs: refillPacks,
          stix: refillPacks * 10,
          selling_plan_id: sellingPlanId || null,
        });
        if (root.dataset.afterAdd === 'cart') redirectToCart();
        else showToast(root, `${refillPacks * 10} Waxx Stix added to cart.`);
      } catch (error) {
        showToast(root, error.message || 'Unable to add refills to the cart.', true);
      } finally {
        busy = false;
        button.disabled = false;
      }
    });

    publish('waxxpod_landing_view', {
      section_id: root.dataset.sectionId,
      language: document.documentElement.lang,
    });
  }

  function initializeAll(container = document) {
    container.querySelectorAll(ROOT_SELECTOR).forEach(initialize);
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', () => initializeAll());
  } else {
    initializeAll();
  }

  document.addEventListener('shopify:section:load', (event) => initializeAll(event.target));
  document.addEventListener('shopify:section:unload', () => {
    window.setTimeout(() => {
      if (!document.querySelector(ROOT_SELECTOR)) document.body.classList.remove('wp-landing-active');
    });
  });
})();